












































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import EventBus from '@/plugins/EventBus'
import SuporteSalasRoboticasStore from '@/components/Suporte/Store/SuporteSalasRoboticasStore'

type SalaRobotica = {
  id: string
  descricao: string
  status: string
  hospitalId: string
  createdOn: string
  createdBy: string
}

@Component
export default class ComponentModalSolicitacaoCirurgiaTecnicaRobotica extends Vue {
  inputSearch: string = ''
  selectedSalaRobotica: SalaRobotica | null = null
  loading: any = {
    listText: 'Sala robótica não encontrada.',
  }

  get store() {
    return getModule(SuporteSalasRoboticasStore, this.$store)
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  get showModalTecnicaRobotica() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showTecnicaRobotica
  }

  get getSalasRoboticas(): SalaRobotica[] {
    return this.store.salasRoboticas as SalaRobotica[]
  }

  get getSalasRoboticasAtivas(): SalaRobotica[] {
    return this.getSalasRoboticas.filter((sala: SalaRobotica) => sala.status === 'Ativo')
  }

  get getSalasRoboticasFiltradas(): SalaRobotica[] {
    const search = this.normalizeText(this.inputSearch)

    if (!search) {
      return this.getSalasRoboticasAtivas
    }

    return this.getSalasRoboticasAtivas.filter(sala => this.normalizeText(sala.descricao).includes(search))
  }

  get canCloseWithoutSelection() {
    if (!this.isSalaRoboticaObrigatoria) {
      return true
    }

    return this.getSalasRoboticasAtivas.length === 0
  }

  get canConfirm() {
    if (!this.isSalaRoboticaObrigatoria) {
      return true
    }

    if (this.getSalasRoboticasAtivas.length === 0) {
      return true
    }

    return !!this.selectedSalaRobotica
  }

  get isSalaRoboticaObrigatoria() {
    const template = this.getSolicitacaoCirurgiaStore.currentTemplate
    const formulario = template && template.formulario
    const tecnicaDaCirurgia = formulario && formulario.tecnicaDaCirurgia
    const tecnicaEhRobotica = tecnicaDaCirurgia && tecnicaDaCirurgia.tecnicaEhRobotica

    return !!(tecnicaEhRobotica && tecnicaEhRobotica.obrigatorio)
  }

  @Watch('showModalTecnicaRobotica')
  onChangeGetShowModalTecnicaRobotica(value) {
    if (value) {
      const salaRoboticaDescricao = this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.salaRobotica
      this.selectedSalaRobotica = (this.getSalasRoboticasAtivas.find(sala => sala.descricao === salaRoboticaDescricao) as SalaRobotica) || null
    }

    setTimeout(() => {
      const input = document.querySelector(
        '.equipamento-input input',
      ) as HTMLInputElement
      if (value) {
        input.focus()
      } else {
        input.blur()
      }
    }, 100)
  }

  toggleBodyOverflow(isOpen: Boolean) {
    const html = document.querySelector('body')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
      }
    }
  }

  selectSalaRobotica(salaRobotica: SalaRobotica) {
    this.selectedSalaRobotica = salaRobotica
  }

  clearSelectedSalaRobotica() {
    this.selectedSalaRobotica = null
  }

  normalizeText(value: string = '') {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
  }

  async confirmSelectedSalaRobotica() {
    if (this.isSalaRoboticaObrigatoria && !this.canConfirm) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Selecione uma sala robótica para confirmar.',
        icon: 'warning',
        color: '#C62828',
      })
      return
    }

    if (!this.selectedSalaRobotica) {
      this.getSolicitacaoCirurgiaStore.setSolicitacaoCirurgiaFields({
        field: 'salaRobotica',
        value: null,
      })
      this.closeModalTecnicaRobotica()
      return
    }

    this.getSolicitacaoCirurgiaStore.setSolicitacaoCirurgiaFields({
      field: 'salaRobotica',
      value: this.selectedSalaRobotica.descricao,
    })

    this.closeModalTecnicaRobotica()
  }

  closeModalTecnicaRobotica() {
    if (this.isSalaRoboticaObrigatoria && !this.canCloseWithoutSelection && !this.selectedSalaRobotica) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Selecione e confirme uma sala robótica para fechar o modal.',
        icon: 'warning',
        color: '#C62828',
      })
      return
    }

    this.clear()
    this.getSolicitacaoStore.setShowModalTecnicaRobotica(false)
  }

  clear() {
    this.getInputSearch = ''
    this.selectedSalaRobotica = null
  }
}
